import { publicWildcardIsEnvironmentControlled } from "../../shared/publicUrl";

// The domain space public URLs live under, plus the tenant label to combine
// with the space slug when both share one DNS label. Single-tenant stacks use
// PUBLIC_WILDCARD_DOMAIN as-is unless the combined host shape is configured.
// Multi-tenant stacks compose the tenant's domain from STACK_PUBLIC_BASE_DOMAIN
// and the tenant's public_domain label. The
// tenant label is dot-joined (`<slug>.<tenant>.<base>`) unless the stack sets
// PUBLIC_COMBINED_SPACE_TENANT_HOSTS, whose TLS wildcard covers only one label
// so the tenant fuses onto the slug with a double dash
// (`<slug>--<tenant>.<base>`). With no base domain (localhost in
// development) there is no isolation and the caller falls back to the bare
// public host; a base with no tenant label is a broken stack, not a
// fallback.

export type PublicDomain = {
  wildcardDomain: string | undefined;
  combinedSpaceTenantLabel?: string;
};

export function derivePublicDomain(
  publicWildcardDomain: string | undefined,
  stackPublicBaseDomain: string | undefined,
  maxTenants: number,
  combinedSpaceTenantHosts: boolean,
  tenantPublicDomain: string | undefined
): PublicDomain {
  if (
    publicWildcardIsEnvironmentControlled(maxTenants, combinedSpaceTenantHosts)
  ) {
    return { wildcardDomain: publicWildcardDomain };
  }
  if (!stackPublicBaseDomain) {
    return { wildcardDomain: undefined };
  }
  if (!tenantPublicDomain) {
    throw new Error("derivePublicDomain: no tenant label on a SaaS stack");
  }
  if (combinedSpaceTenantHosts) {
    return {
      wildcardDomain: stackPublicBaseDomain,
      combinedSpaceTenantLabel: tenantPublicDomain,
    };
  }
  return {
    wildcardDomain: `${tenantPublicDomain}.${stackPublicBaseDomain}`,
  };
}
